export default "__VITE_ASSET__B2QlpPZj__"